import styled from 'styled-components';

import {getColorCss} from './utils/color';

const List = styled.div`
  --list-padding: 0.5rem;
  ${getColorCss('surface')}
  padding: var(--list-padding) 0;
  overflow: auto;
  display: flex;
  flex-direction: column;
  align-items: stretch;
`;

export default List;
